export default __webpack_public_path__ + "static/Poppins-Medium-13c404f85f4b8532e4e9e256d31f4115.woff2";